angular.module('sample.widgets.quickFindProject',
    [
        'adf.provider',
        "ngResource",
        "ivpusic.cookie",
        "EICDataStream3.resources",
        "ui.router",
        'ui.bootstrap.tooltip'
    ])
    .config(['dashboardProvider', function (dashboardProvider) {
        dashboardProvider
            .widget('quickFindProject',
                {
                    id: 'quickFindProject',
                    title: 'Find a Project by Name or ID',
                    description: 'Find a project by name or ID',
                    controller: 'QuickFindProjectController',
                    //   controllerAs: 'list',
                    templateUrl:
                        '/app-ds3/dashboard/widgets/quickFindProject2/quickFindProject.partial.html' //,
                    //            edit:         {
                    //              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
                    //              reload:      false,
                    //              controller:  'linklistEditCtrl'
                    //            }
                });
    }])
    .controller('QuickFindProjectController',
        [
            '$scope', '$rootScope', '$http', '$q', '$state', 'searchService', 'featuresService',
            function ($scope, $rootScope, $http, $q, $state, searchService, featuresService) {
                $scope.componentName = "QuickFindProjectController";

                var projectNameRequestCanceler = null;
                var projectIdRequestCanceler = null;

                //   $scope.title = 'Quickly Locate a Project by Name';

                $scope.clearProjectName = function () {
                    delete $scope.criteria["projectName"];
                };
                $scope.clearProjectID = function () {
                    delete $scope.criteria["projectId"];
                };

                //----------  Project Name autocomplete function  ----------------------------
                var search = function (request, response) {

                    var callback = function (r) {
                        let data = r?.data;
                        // var list = [];
                        // for (var i = 0; i < data.length; i++) {
                        //     var thisItem = {
                        //         label: data[i].name,
                        //         value: data[i].name
                        //     };

                        //     list.push(thisItem);
                        // }
                        response(data);
                    };

                    if (projectNameRequestCanceler) {
                        projectNameRequestCanceler.resolve();
                    }
                    projectNameRequestCanceler = $q.defer();

                    $http.get("/api/projectnamesuggestions?limit=11&q=" + JSON.stringify($scope.criteria), {
                        timeout: projectNameRequestCanceler.promise
                    })
                        .then(callback)
                        .catch(function (data, status, headers, config) {
                            let i = 0;
                            // called asynchronously if an error occurs
                            // or server returns response with an error status.
                        });
                },

                    _renderItem = function (ul, item) {
                        var itemName = (item.name.length > 40) ? item.name.substring(0, 39) + "&hellip;" : item.name;
                        if (featuresService.enableLifecycleSecurity){
                            itemName = `(${item.discriminator[0]}) ${itemName}`;
                        }
                        if (ul.children().length < 10) {
                            return $("<li class='ui-menu-item' role='presentation'>")
                                .data("item.autocomplete", item)

                                //  .append("<a class='ui-corner-all'><div>" + trackingStatusIcon(item.trackingStatusID) + "&nbsp;<span  tabindex='-1'>" + item.name + "</span></div></a>")
                                .append("<a class='ui-corner-all'><span  tabindex='-1'>" + itemName + "</span></a>")


                                // .append("<div>" + trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a></div>")
                                //  .append(trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a>")
                                .appendTo(ul);
                        } else {
                            return $(
                                "<li class='divider' ></li><li class='ui-menu-item' style=color:red;text-align:center;' role='presentation'>more results are available with a more specific search</li>")
                                .appendTo(ul);
                        }


                    },

                    select = function (event, ui) {
                        if (ui.item) {
                            $scope.criteria.projectName = ui.item.name;
                            // $scope.$parent.formChanged();
                            // close the criteria pane
                            //$scope.$emit("DETAIL_PAGE_ACTIVATED", true);
                            $scope.$parent.showFilterContainer = false;
                            $state.go('search.project',
                                { projectID: ui.item.projectID, projectName: ui.item.name.urlEncode() });
                        }
                    };

                $scope.autocompleteOptions = {
                    minLength: 2,
                    source: search,
                    select: select,
                    delay: 500,
                    _renderItem: _renderItem
                };

                //----------  Project ID autocomplete function  ----------------------------
                var searchId = function (request, response) {

                    var callback = function (r) {
                        let data = r?.data;
                        //var list = [];
                        //for (var i = 0; i < data.length; i++) {
                        //    var thisItem = {
                        //        label: data[i].projectID,
                        //        value: data[i].projectID
                        //    };

                        //    list.push(thisItem);
                        //}
                        response(data);
                    };

                    if (projectIdRequestCanceler) {
                        projectIdRequestCanceler.resolve();
                    }
                    projectIdRequestCanceler = $q.defer();

                    $http.get("/api/projectIdSuggestions?limit=11&q=" + JSON.stringify($scope.criteria), {
                        timeout: projectIdRequestCanceler.promise
                    })
                        .then(callback)
                        .catch(function (data, status, headers, config) {
                            let i = 0;
                            // called asynchronously if an error occurs
                            // or server returns response with an error status.
                        });
                };

                var _renderItem_id = function (ul, item) {
                    var itemName = item.projectID;
                    if (featuresService.enableLifecycleSecurity) {
                        itemName = `(${item.discriminator[0]}) ${itemName}`;
                    }
                    if (ul.children().length < 10) {
                        return $("<li class='ui-menu-item' role='presentation'>")
                            .data("item.autocomplete", item)

                            //  .append("<a class='ui-corner-all'><div>" + trackingStatusIcon(item.trackingStatusID) + "&nbsp;<span  tabindex='-1'>" + item.name + "</span></div></a>")
                            .append("<a class='ui-corner-all'><span  tabindex='-1'>" + itemName + "</span></a>")


                            // .append("<div>" + trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a></div>")
                            //  .append(trackingStatusIcon(item.trackingStatusID) + "<a class='ui-corner-all'  style='display:inline' tabindex='-1'>" + item.name + "</a>")
                            .appendTo(ul);
                    } else {
                        return $(
                            "<li class='divider' ></li><li class='ui-menu-item' style=color:red;text-align:center;' role='presentation'>more results are available with a more specific search</li>")
                            .appendTo(ul);
                    }


                };

                var selectId = function (event, ui) {
                    if (ui.item) {
                        $scope.criteria.projectId = ui.item.value;
                        // $scope.$parent.formChanged();
                        // close the criteria pane
                        //$scope.$emit("DETAIL_PAGE_ACTIVATED", true);
                        $scope.$parent.showFilterContainer = false;
                        $state.go('search.project',
                            { projectID: ui.item.projectID, projectName: ui.item.name.urlEncode() });
                    }
                };

                $scope.autocompleteOptions_id = {
                    minLength: 2,
                    source: searchId,
                    select: selectId,
                    delay: 500,
                    _renderItem: _renderItem_id
                };


                //$scope.newProjectSearch = function () {
                //  searchService.searchType= "project";
                //  $state.go("search");
                //};


                //$scope.newOperatingCompanySearch = function () {

                //};


                //$scope.newContractAwardSearch = function () {
                //  searchService.searchType = "contractAward";
                //  $state.go("search");
                //};

                $scope.$on('$viewContentLoaded',
                    function () {
                    });
                $scope.$on('$destroy',
                    function () {
                        if (projectNameRequestCanceler) {
                            projectNameRequestCanceler.resolve();
                        }
                        if (projectIdRequestCanceler) {
                            projectIdRequestCanceler.resolve();
                        }
                    });
            }
        ]);


